<template>
	<div v-if="timeSlots.length === 0" class="mb-3 p-3 bg-contrast-400">
		<p class="small fw-bold m-0" data-testid="no-time-slots">
			Sorry, there are no times available, please select another date.
		</p>
	</div>
	<div v-if="timeSlots.length > 0" class="time-slots d-flex flex-wrap pt-3 pb-1">
		<button
			v-for="(timeSlot, index) in timeSlots"
			:key="index"
			class="btn btn-outline-dark"
			:class="{ active: isSelected(timeSlot) }"
			type="button"
			:aria-label="formatDate(timeSlot.startTime, 'h:mmA', timeSlot.timeZone)"
			data-testid="btn-time-slot"
			@click="onTimeClick(timeSlot)"
		>
			{{ formatDate(timeSlot.startTime, 'h:mmA', timeSlot.timeZone) }}
		</button>
	</div>

	<p class="small m-0">
		Time slots are representative of the club's local time zone. Bookings can be made up to two
		weeks in advance.
	</p>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { useDates } from '@/composables/use-dates';
import { useField } from 'vee-validate';
import type { ITimeSlot } from 'Types/aemui/schedule-a-tour/scheduleATour';
const { formatDate } = useDates();

const props = defineProps({
	modelValue: {
		type: Object as PropType<ITimeSlot | null>,
		default: null
	},
	timeSlots: {
		type: Array as PropType<ITimeSlot[]>,
		default: () => []
	}
});

const emit = defineEmits<{
	(e: 'update:modelValue', value: ITimeSlot): void;
}>();

const { setValue } = useField<ITimeSlot>('timeSlot');

function isSelected(timeSlot: ITimeSlot) {
	return props.modelValue?.startTime === timeSlot.startTime;
}

function onTimeClick(timeSlot: ITimeSlot) {
	emit('update:modelValue', timeSlot);
	setValue(timeSlot);
}
</script>

<style lang="scss" scoped>
.time-slots {
	.btn {
		@include font-size($btn-font-size-sm);
		flex: 0 0 auto;
		width: 5rem;
		margin: 0 0.5rem 0.5rem 0;
		padding: 0.25rem 0;
		text-align: center;

		@include media-breakpoint-up(md) {
			margin: 0 1rem 1rem 0;
		}
	}
}
</style>
